// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-0a7bb0ee] {\n  font-size: 32px;\n  color: #ff0000;\n  text-align: center;\n  line-height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
